import { render, staticRenderFns } from "./FormResponsables.vue?vue&type=template&id=4d97872b"
import script from "./FormResponsables.vue?vue&type=script&lang=js"
export * from "./FormResponsables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports